import { Component, AfterViewInit, NgZone, ViewChild, ChangeDetectorRef, } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import {
  TdLoadingService,
  TdMediaService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
} from '@covalent/core';

import { Nota } from '../../../models';
import { NotasService, LoginService, } from '../../../services/';

@Component({
  selector: 'qs-notas',
  templateUrl: './notas.component.html',
  styleUrls: ['./notas.component.scss'],
  providers: [NotasService],
})
export class NotasComponent implements AfterViewInit {

  private idPaciente: string;
  private dniMedico: string;
  private notas: Nota[];

  // ITDdDataTableComponent
  // Columnas
  private columnsAll: ITdDataTableColumn[] = [
    { name: 'idPostit', label: 'Número Expediente', hidden: true },
    { name: 'fecha', label: 'Fecha', tooltip: 'Estado', sortable: true },
    { name: 'comentario', label: 'Comentario', tooltip: 'Comentario', sortable: false },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: Nota[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'idPostit';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  @ViewChild(TdDataTableComponent) tableComponent: TdDataTableComponent;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _notasService: NotasService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef, ) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Notas');
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.dniMedico = this._loginService.profesional.Dni;
    this._loadingService.register('notas.load');
    this._notasService.obtenerNotas(this.idPaciente, this.dniMedico, false).subscribe((res: any) => {
      this.notas = res.respuesta.notas || [];
      this.filteredData = this.notas;
      this.filteredDataTotal = this.notas.length;
      this._loadingService.resolve('notas.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo notas.', 'OK', 6000);
      this._loadingService.resolve('notas.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  /**
   * openDetail: Muestra la vista de detalle pasando la linea seccionada
   * @param any: $event <- Fila seleccionada
   */
  openDetail(nota: Nota): void {
    if (nota) {
      this._loginService.transient = nota;
      this._router.navigate(['editar/', nota.idPostit], { relativeTo: this._route });
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.notas;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/notas/notas.component.ts